import * as React from 'react'
import styled from 'styled-components'
import { colors, GoodSansH3 } from '@components/shared'
import { config } from 'react-awesome-styled-grid'

export const TopBanner = (props: {
  bannerText: string,
  noNavBar?: boolean,
  hideTagIcon?: boolean,
  zIndex?: number,
  isPositionSticky?: boolean,
  backgroundColor?: string,
  background?: string
}): React.ReactNode => {
  return (
    <Banner
      noNavBar={!!props.noNavBar}
      zIndex={props.zIndex}
      isPositionSticky={props.isPositionSticky}
      backgroundColor={props.backgroundColor || colors.orange}
      background={props.background || 'unset'}
    >
      <div>
        {!props.hideTagIcon && <TagIcon />}
        <p dangerouslySetInnerHTML={{ __html: props.bannerText }} />
      </div>
    </Banner>
  )
}

const Banner = styled.div<any>`
  background: ${(props: { background: string }): string => props.background || 'unset'};
  background-color: ${(props: { backgroundColor: string}): string => props.backgroundColor};
  width: 100%;
  z-index: ${(props: any): number => props.zIndex || 1};
  position: ${(props: any): string =>
    props.isPositionSticky ? 'sticky' : 'absolute'};
  top: ${(props: { noNavBar: boolean }): string =>
    props.noNavBar ? '0' : '60px'};
  ${(props: any): any => config(props).media.md`
    top: ${(props: { noNavBar: boolean }): string =>
      props.noNavBar ? '0' : '75px'};
  `}

  div {
    align-items: center;
    display: flex;
    flex: 1;
    padding: 16px;
    ${(props: any): any => config(props).media.sm`
      justify-content: center;
      padding: 14px 16px;
    `}
    ${(props: any): any => config(props).media.md`
      padding: 18px 16px;
    `}
  }
  svg {
    min-height: 20px;
    min-width: 20px;
  }
  p {
    ${GoodSansH3};
    ${(props: any): any => config(props).media.md`
      font-size: 14px
    `}
    padding: 0;
    margin: 0 0 0 14px;
    span {
      text-decoration: underline;
    }
  }
`
const TagIcon = (): React.ReactNode => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.77167 8.87946L10.7623 17.8699L17.8696 10.7622L8.87183 1.76452H1.91085L1.77167 8.87946ZM10.7623 19.9999C10.5283 19.9999 10.304 19.9069 10.1385 19.7414L0.258529 9.86142C0.08869 9.69202 -0.00461126 9.46042 0.000241289 9.22044L0.163463 0.865016C0.172727 0.384393 0.564902 -6.10352e-05 1.04552 -6.10352e-05H9.23751C9.47131 -6.10352e-05 9.69585 0.0930197 9.86128 0.258447L19.7413 10.1385C20.0858 10.483 20.0858 11.0417 19.7413 11.386L11.3861 19.7414C11.2207 19.9069 10.9961 19.9999 10.7623 19.9999Z'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.99866 5.62457C6.99866 6.29467 6.4554 6.83771 5.78552 6.83771C5.11543 6.83771 4.57239 6.29467 4.57239 5.62457C4.57239 4.9547 5.11543 4.41144 5.78552 4.41144C6.4554 4.41144 6.99866 4.9547 6.99866 5.62457Z'
        fill='white'
      />
    </svg>
  )
}
